import React, {useRef, useState} from 'react';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import {cookies_string} from '../config.js';
import { Login } from '../actions/actions.js';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useLang } from '../hook/UseLang.js';
import '../App.css'
import './news.css'
import '../components/home/home.css'

//
import Mask from './components/MaskAnimation.js';
import Carousell from '../components/caro.js';
import Footer from './components/Footer.js';
import InViewComponent from './components/InView.js';
import PageSelector from '../components/PageSelector.js'
//
import LeftSvg from '../svgs/facility/leftSvg.js'
import RightSvg from '../svgs/facility/rightSvg.js'
//
import CONTENT from '../contents/new.js'

const TAGS = ['ALL', 'event','information', 'press']
let NEWS = [
    {
        title:'Location Information',
        date:'2025.05.05',
        catagory:''
    },
    {
        title:'Enjoy the summer! Limited to 3 sets of dinner set menus per day-Since June 1st-',
        date:'2025.05.08',
        catagory:''
    },
    {
        title:'【Limited】Collaboration event is currently being held',
        date:'2025.05.12',
        catagory:''
    },
    {
        title:'Notice of closure due to major renovations',
        date:'2025.05.20',
        catagory:''
    },
    {
        title:'Club Breakaway Staycation',
        date:'2015.05.25',
        catagory:''
    },
    {
        title:'Information on accepting New Year holiday reservations',
        date:'2025.05.30',
        catagory:''
    },
    {
        title:'Unbeatable Sweet Promotion',
        date:'2025.06.03',
        catagory:''
    },
    {
        title:'Collaborative activities are currently underway',
        date:'2025.06.10',
        catagory:''
    },
    {
        title:'All new liquor store supplies',
        date:'2025.06.13',
        catagory:''
    },
    {
        title:'Fee Change Notice',
        date:'2025.06.20',
        catagory:''
    },
    {
        title:'Early Bird Flash Sales',
        date:'2025.06.23',
        catagory:''
    },
    {
        title:'Stay, Dine & Earn',
        date:'2025.06.28',
        catagory:''
    },
    {
        title:'Breakaway Staycation',
        date:'2025.07.05',
        catagory:''
    },
    {
        title:'Update notification',
        date:'2025.07.10',
        catagory:''
    },
    {
        title:'Long Staying Specials',
        date:'2025.07.16',
        catagory:''
    },
    {
        title:'Football Fan Getaway Package',
        date:'2025.07.18',
        catagory:''
    },
]
NEWS.forEach((obj, i) => {
    NEWS[i].catagory = TAGS[i % TAGS.length]
    NEWS[i].img = 'n'+i

})
NEWS = [...NEWS, ...NEWS.slice(0,9)]
function Component({}) {
    const navigate = useNavigate();
    const location = useLocation();
    const [ __, _, removeCookie] = useCookies([`${cookies_string}_cred`,`${cookies_string}_token`]);
    const [searchParams, setSearchParams] = useSearchParams();
    const [lang, setLang] = useLang()

    //
    const ref1 = useRef()
    const ref2 = useRef()
    const cut1 = useRef()
    
    const [selectedFilter, setSelectedFilter] = useState(null)
    //
    const [total, setTotal] = useState(NEWS.length);
    const page =  parseInt(searchParams.get('page'))||1;
    const LIMIT = 16
    const totalPage = Math.ceil(total / LIMIT)

    const handleSetParams = (key, value) => {
        searchParams.delete(key)
        searchParams.append(key, value)
        setSearchParams(searchParams)
    }
    const handleSelectPage=(p)=> async ()=>{
        if(p > totalPage || p < 1) return;
        handleSetParams('page', p)
    }

    const handleSelectedFilter = (tag) => {
        if(tag === 'ALL' || tag === selectedFilter) return setSelectedFilter(null)
        setSelectedFilter(tag)
    }
    
    return(
        <div className='bg-white w-full flex flex-col'>
            <div className='w-full flex flex-col'>
                {/* sec1 */}
                <div className='w-full h-[50vh] addnavpadding relative'>
                    <div className='absolute bottom-5 left-5 vert-text text-white text-[8px] font-[500] m-show-d-hidden'>No. 21 Whitfield Road Causeway Bay Hong Kong Island Hong Kong</div>
                    <img src='./images/facility/banner.jpg' className='w-full h-full' style={{objectFit:'cover'}}></img>
                </div>
                <div className='relative x-padding w-full min-h-[100vh] flex flex-col items-center justify-start'>
                    <div id='news and topics' className='absolute top-[-10vh]'></div>
                    <img src='./images/bg_texture.jpg' className='absolute w-full h-full' style={{objectFit:'cover'}}></img>
                    <InViewComponent reffing={ref1} active='title_text_active'delay={2000}/>
                    <div ref={ref1} className='title_text relative text-d-35 playfair-display my-[79px]'>news and topics</div>
                    <div  ref={cut1} className='cut_down w-[1px] h-[70px] absolute top-0 left-50 bg-black'></div>
                    <InViewComponent reffing={cut1} active='cut_down_active'delay={2000}/>
                    <div className='relative w-[90%] news-max-w flex flex-col pb-[48px]'>
                        <div ref={ref2} className='title_text w-full flex flex-row items-center mb-[48px]'>
                            {TAGS.map((tag, i ) => <div className=''>
                                <div key={tag+i} className='text-d-12 cursor-pointer inline-block hover:font-bold py-[5px] select-none' onClick={() => handleSelectedFilter(tag)}>{tag}</div> 
                                {i !== TAGS.length - 1 &&<span className='px-[12px] text-[12px]'>/</span>}
                            </div>)} 
                        </div>
                        <InViewComponent reffing={ref2} active='title_text_active' delay={3000}/>
                        <div className='flex flex-row flex-wrap items-between justify-between-center mb-[128px] grid grid-cols-1 md:grid-cols-4 gap-4' style={{rowGap:48}}>
                            {NEWS.slice((page - 1) * LIMIT, (page - 1) * LIMIT + LIMIT ).filter((obj,i) => {
                                if(!selectedFilter) return obj
                                if(selectedFilter === obj.catagory) return obj
                            }).map((obj, i) => (
                                <div className='relative flex flex-col items-center justify-start min-w-[294px] w-full max-w-[12vw] cursor-pointer' onClick={() => navigate(`/news/${i}?lang=${lang}`, { state: obj })}>
                                    {/* overlay */}
                                    <div className='flex flex-col items-center justify-start w-full h-full'>
                                        <div className='relative overflow-hidden select-none overflow-hidden w-full'>
                                            <div className='absolute w-full h-full appear-cover-2 flex flex-col items-center justify-center' style={{zIndex:2}}>
                                                <div className='flex flex-col items-center justify-center w-[70%] h-[90%]' style={{gap:24}}>
                                                    <div className='w-[118px] h-[118px] relative topleft-cutto-bottomright'>
                                                    <div className='w-full h-[1px] absolute top-[50%] bg-[#0FBAB5]'></div>
                                                    <div className='w-[1px] h-full absolute left-[50%] bg-[#0FBAB5]'></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <img className='relative w-full h-full' style={{objectFit:'cover'}} src={`./images/news/${obj.img}.jpg`}></img>
                                        </div>
                                        <div className='text-d-10 text-[#0FBAB5] select-none'>{obj.date}</div>
                                        <div className='text-d-12 text-center'>{obj.title}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <PageSelector hideTotal={true} page={page} total={total} totalPage={totalPage} handleSelectPage={handleSelectPage} />
                    </div>
                </div>
                {/* sec2 */}
            </div>
            <Footer />
            <Mask />
        </div>
    )
}
export default connect((store)=>{
    return{
      token:store.tokenReducer,
    }
  })(Component)